import assets from "../../config/assets";

export const QdsWebHeader = () => {
  return (
    <div
      style={{
        height: 65,
        display: "flex",
        alignItems: "center",
        paddingLeft: 20,
        backgroundColor: "#00264d",
      }}
    >
      <div>
        <img src={assets.images.logoBigOnDark} alt="Aurora logo" />
      </div>
    </div>
  );
};
